module.exports = __webpack_public_path__ + "img/1528859878.caaf2ccd.jpg";